import styled, { css } from 'styled-components';

export const MaxContainer = styled.div<{ bg?: string; mobile?: boolean }>`
  position: relative;
  background-size: cover;
  width: calc(100vw - 30px);
  margin: 0 auto;
  ${({ mobile }) =>
    mobile &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}
  @media (min-widht: 575px) {
    display: block;
  }

  @media (min-width: 768px) {
    max-width: 1140px;
    width: 680px;
    margin: 0;
  }

  & .affiliate-actions {
    position: absolute;
    width: 40px;
    height: 80px;
    left: 0;
    top: 0;
    z-index: 10;

    & > div,
    & > div > a {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
    }

    .copy-button {
      background-color: #ffffff;
      & > div > svg {
        margin-right: 0;
      }
    }

    .download-trailer {
      margin-top: 3px;
      a {
        background-color: #222;
      }
    }

    @media (max-width: 630px) {
      display: none;
    }
  }
`;

export const Opacity = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1;
`;

export const PlayIconWrapper = styled.div`
  background-color: rgba(0, 213, 222, 0.8);
  width: 62.5px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  @media (min-width: 575px) {
    display: none;
  }
`;

export const MainVideo = styled.div`
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  position: absolute;
  background-color: rgb(80, 80, 80);
`;
